import "./image-map-resize.js";

export function coverageMap() {
    $(".coverage-map").each(function (n, el) {
        initCoverageMap(el);
    });
}

function initCoverageMap(el) {
    let $map = $(el);

    // handle image map resizes
    $("map").imageMapResize();

    // set active region
    setRegion($map, "australia");

    // handle clicks
    $("area, a", $map).on("click", function (e) {
        e.preventDefault();
		e.stopPropagation();

        let region = $(this).attr("href").replace("#", "");
        console.log("click region", region);
        setRegion($map, region);
    });

    // handle region click on element
    $(".region", $map).on("click", function (e) {
        e.preventDefault();
        let region = $(this).data("up");

        if (region) {
            console.log("click UP", region);
            setRegion($map, region);
        }
    });
}

function setRegion($map, region) {
    $(".region", $map).removeClass("active");
    $(".region", $map)
        .filter('[data-region="' + region + '"]')
        .addClass("active");

    // handle image map resizes
    $("map").imageMapResize();
}
